'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var React = require('react');
require('@emotion/react');
require('../../../../../aviary-core/dist/cjs/index.cjs');
require('../../../../../../node_modules/@fortawesome/react-fontawesome/index.es.cjs');
require('@remix-run/react');
require('react-router-dom');
require('../../../utils/AviaryProvider/AviaryThemeContext.cjs');
require('../../../../../aviary-tokens/dist/cjs/index.cjs');
require('aviary-tokens');
var InternalTextInput_web = require('../../internal/InternalTextInput/InternalTextInput.web.cjs');
require('../../internal/InternalToggle/InternalToggle.web.cjs');
var InternalInputIcon_web = require('../../internal/InternalInputIcon/InternalInputIcon.web.cjs');

/**
 * PasswordInput component is used to display an password input field
 * Includes validation for required onBlur
 *
 * {@link https://aviary.fullscript.io/latest/components/password-input/web-xz2xsZma | Documentation}
 *
 * {@link https://git.fullscript.io/developers/aviary/-/blob/development/packages/aviary-web/src/components/molecules/PasswordInput/PasswordInput.web.tsx | View in GitLab}
 *
 * @scope Core
 */ const PasswordInput = ({ label, value, disabled, ...rest })=>{
    const [isPasswordShown, setIsPasswordShown] = React.useState(false);
    const displayedLabel = label || "Password";
    const renderEndContent = ()=>{
        if (!value || disabled) return null;
        return /*#__PURE__*/ jsxRuntime.jsx(InternalInputIcon_web.InternalInputIcon, {
            icon: isPasswordShown ? "passwordVisible" : "passwordHidden",
            onClick: ()=>setIsPasswordShown((prevState)=>!prevState),
            "aria-label": isPasswordShown ? "Hide password" : "Show password",
            disabled: disabled
        });
    };
    return /*#__PURE__*/ jsxRuntime.jsx(InternalTextInput_web.InternalTextInput, {
        "data-testid": "aviary-password-input",
        type: isPasswordShown ? "text" : "password",
        label: displayedLabel,
        value: value,
        rightContent: renderEndContent(),
        disabled: disabled,
        ...rest
    });
};

exports.PasswordInput = PasswordInput;
//# sourceMappingURL=PasswordInput.web.cjs.map
